import { render, staticRenderFns } from "./pages19.vue?vue&type=template&id=35fc0c15&scoped=true&"
import script from "./pages19.vue?vue&type=script&lang=js&"
export * from "./pages19.vue?vue&type=script&lang=js&"
import style0 from "./pages19.vue?vue&type=style&index=0&id=35fc0c15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc0c15",
  null
  
)

export default component.exports